import { combine } from 'effector';
import {
  homeRoute, projectsRoute, enHomeRoute, enProjectsRoute,
} from 'src/models/routes';

// Stores

// Locale is derived from the matched route only — no navigator/localStorage guessing.
export const $locale = combine(
  enHomeRoute.$isOpened,
  enProjectsRoute.$isOpened,
  (enHomeOpened, enProjectsOpened) => (enHomeOpened || enProjectsOpened ? 'en' : 'ru'),
);

export const $isProjectsPage = combine(
  projectsRoute.$isOpened,
  enProjectsRoute.$isOpened,
  (ruProjectsOpened, enProjectsOpened) => ruProjectsOpened || enProjectsOpened,
);

// Route map per locale

export const localeRoutes = {
  ru: { home: homeRoute, projects: projectsRoute },
  en: { home: enHomeRoute, projects: enProjectsRoute },
};
